import React from "react";
import classNames from "classnames";
import DatePicker from "../date-picker/date-picker";
import TimePickerInput from "../time-picker-input/time-picker-input";
import { combineDateAndTimeInput } from "utils";
import styles from "./date-time-picker-v2.module.scss";

const DateTimePickerV2 = ({
  value,
  onChange,
  name,
  datePlaceholder = "Select date",
  timePlaceholder = "--:-- --",
  disabled,
  className,
  disableStartDate,
  disableEndDate,
  minDateTime,
}) => {
  const min = minDateTime ? new Date(minDateTime) : null;

  const handleDateChange = (_, { value: newDate }) => {
    let combined = value ? combineDateAndTimeInput(newDate, value) : newDate;
    if (min && combined < min) combined = new Date(min);
    onChange?.(name, { value: combined });
  };

  const handleTimeChange = (_, { value: newTime }) => {
    let combined = value ? combineDateAndTimeInput(value, newTime) : newTime;
    if (min && combined < min) combined = new Date(min);
    onChange?.(name, { value: combined });
  };

  return (
    <div className={classNames(styles.container, className, { [styles.disabled]: disabled })}>
      <DatePicker
        value={value}
        onChange={handleDateChange}
        placeholder={datePlaceholder}
        disabled={disabled}
        disableStartDate={min || disableStartDate}
        disableEndDate={disableEndDate}
        className={styles.datePicker}
        hideIcon
      />
      <div className={styles.divider} />
      <TimePickerInput
        value={value || null}
        onChange={handleTimeChange}
        placeholder={timePlaceholder}
        disabled={disabled}
        className={styles.timePicker}
        actions={{ cancel: true, ok: true }}
      />
    </div>
  );
};

export default DateTimePickerV2;
